export default { sha: '6f5970f9416913c649e4ba23a2c2de8723cc022a', buildNumber: 'undefined' }
